import t from "./ghl-ui.es834.js";
import o from "./ghl-ui.es835.js";
import a from "./ghl-ui.es836.js";
import r from "./ghl-ui.es837.js";
import m from "./ghl-ui.es838.js";
var e = {
  code: "it",
  formatDistance: t,
  formatLong: o,
  formatRelative: a,
  localize: r,
  match: m,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const s = e;
export {
  s as default
};
